
const Cookie =
{
   set: function(name: string, value:string | null, days:number)
   {
      var domain: string, date: Date, expires: string, host: string;

      if (days)
      {
         date = new Date();
         date.setTime(date.getTime()+(days*24*60*60*1000));
         expires = "; expires="+date.toUTCString();
      }
      else
      {
         expires = "";
      }

      host = window.location.host;
      if (host.split('.').length === 1)
      {
         // no "." in a domain - it's localhost or something similar
         document.cookie = name+"="+value+expires+"; path=/";
      }
      else
      {
         // Remember the cookie on all subdomains.

         // domainParts = host.split('.');
         // domainParts.shift();
         domain = '.falconbrick.com'

         document.cookie = name+"="+value+expires+"; path=/; domain="+domain;

         // check if cookie was successfuly set to the given domain
         // (otherwise it was a Top-Level Domain)
         if (Cookie.get(name) == null || Cookie.get(name) != value)
         {
            // append "." to current domain
            domain = '.'+host;
            document.cookie = name+"="+value+expires+"; path=/; domain="+domain;
         }
      }
   },

   get: function(name: string)
   {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i=0; i < ca.length; i++)
      {
         var c = ca[i];
         while (c.charAt(0)===' ')
         {
            c = c.substring(1,c.length);
         }

         if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
   },

   erase: function(name: string)
   {
      Cookie.set(name, '', -1);
   }
};

// module.exports = Cookie;
export default Cookie;